<template>
  <section v-if="list.length > 0" class="featured-good-list">
    <h2>Популярные товары</h2>

    <div class="featured-good-list__grid">
      <featured-good-list-item
        v-for="item in list"
        :key="`best-${item.id}`"
        :item="item"
      />
    </div>
  </section>
</template>

<script>
import FeaturedGoodListItem from "./FeaturedGoodListItem";

export default {
  components: {
    FeaturedGoodListItem,
  },
  props: {
    list: {
      type: Array,
      default: () => [],
    },
  },
};
</script>

<style lang="scss" scoped>
.featured-good-list {
  &__grid {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 0 30px;

    @include media-breakpoint-up(md) {
      grid-template-columns: repeat(3, 1fr);
    }

    @include media-breakpoint-up(lg) {
      grid-template-columns: repeat(6, 1fr);
    }
  }
}
</style>
